import Reveal from "./Reveal";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="bg-ivory py-28 md:py-40 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-14 md:gap-10 items-center">
        <Reveal className="md:col-span-5 relative flex justify-center">
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: "radial-gradient(ellipse 60% 50% at 50% 35%, rgba(198,161,91,0.22), transparent 70%)" }}
          />
          <div className="relative w-72 md:w-96">
            <div className="rounded-t-[999px] overflow-hidden border border-oxblood/25 shadow-[0_40px_80px_-30px_rgba(56,16,11,0.45)]">
              <img
                data-testid="founder-photo"
                src="/founder.jpg"
                alt="Yojna Jaisingh, Founder of Jaipur Furniture"
                className="w-full aspect-[3/4] object-cover object-top hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-oxblood text-ivory px-8 py-3 whitespace-nowrap">
              <span className="font-display italic text-lg">Since 2000</span>
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-7 md:pl-10">
          <Reveal>
            <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">The Founder</p>
            <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight">
              Yojna <em className="text-oxblood font-light">Jaisingh</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 font-display italic text-2xl md:text-3xl text-oxblood leading-snug max-w-2xl">
              “Truly exceptional furniture is never just about aesthetics — it is about quality,
              function, and the people who live with it.”
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 text-ink/70 font-light leading-relaxed text-base max-w-xl">
              Beginning in the industry in 2000, Yojna spent thirteen years mastering design,
              materials and manufacturing before founding Jaipur Furniture in 2013. Her belief
              was simple: earn trust, never chase volume. Today, one satisfied client still leads
              to another — and the name Jaipur Furniture speaks for itself.
            </p>
            <p className="mt-6 text-brass text-xs tracking-[0.35em] uppercase">
              Founder & Creative Director
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
